import { indexOf, meanBy, filter, isNull } from 'lodash'

const state = {
  wards: [],
  rainfall: 0,
  loading: false,
  weather_stations: [
    { id: 'AMCR0022', name: 'Gota', gmap_location_key: 'VzYbB6cSzPzRsSZVA', lat: 23.1017093, lon: 72.5424538 },
    { id: 'AMCR0012', name: 'Dudheswar', gmap_location_key: 'uFRQ3EG45S9PqmgN9', lat: 23.0515883, lon: 72.5836988 },
    { id: 'AMCR0026', name: 'SWZ-Jodhpur', gmap_location_key: '6gDPdBgeHmonsSYe8', lat: 23.0172383, lon: 72.5057567 },
    { id: 'AMCR0027', name: 'Vasna barrage', gmap_location_key: 'gYrVf6HUN2ztin8t7', lat: 23.0007749, lon: 72.5511376 },
    { id: 'AMCR0004', name: 'Usmaanpura', gmap_location_key: 'jMmtBDyHaq9kQgbc7', lat: 23.0484499, lon: 72.5706188 },
    { id: 'AMCR0023', name: 'Jodhpur', gmap_location_key: '7RcTqMawfGFDpVz78', lat: 23.0164014, lon: 72.5154383 },
    { id: 'AMCR0025', name: 'Chandlodiya', gmap_location_key: 'GNCP4mzp1okqM3rh9', lat: 23.0836202, lon: 72.5467544 },
    { id: 'AMCR0016', name: 'Science City', gmap_location_key: '86xmpuB9bJxM8Jij8', lat: 23.0717338, lon: 72.5124252 },
    { id: 'AMCR0005', name: 'Chandkheda', gmap_location_key: 'RQZkh5ADy2UXcuiH8', lat: 23.1104072, lon: 72.5900241 },
    { id: 'AMCR0021', name: 'Bopal', gmap_location_key: 'NBcR6m9xnYTFPvtc9', lat: 23.0168406, lon: 72.4767068 },
    { id: 'AMCR0008', name: 'Kotarpur', gmap_location_key: 'QpqPZHDxFwqTMaZS8', lat: 23.0972331, lon: 72.6574322 },
    { id: 'AMCR0006', name: 'Memco', gmap_location_key: 'KXxm4w6RxmWmQuVY8', lat: 23.0559636, lon: 72.6329983 },
    { id: 'AMCR0009', name: 'Maninagar', gmap_location_key: 'TXBUgNGw1Z8oxqWZA', lat: 22.9975017, lon: 72.6037827 },
    { id: 'AMCR0010', name: 'Vatva', gmap_location_key: 'pbH392DVS3pCgcpC6', lat: 22.9529865, lon: 72.6168229 },
    { id: 'AMCR0011', name: 'Danapith', gmap_location_key: '9zcDoYiTKamDTqag9', lat: 23.0208058, lon: 72.5860702 },
    { id: 'AMCR0014', name: 'Sarkhej', gmap_location_key: 'wYHa7bh48ZzWEevCA', lat: 22.9956696, lon: 72.510611 },
    { id: 'AMCR0013', name: 'Bodakdev', gmap_location_key: null, lat: null, lon: null },
    { id: 'AMCR0001', name: 'Viratnagar', gmap_location_key: 'dgSxb86PqVBiHXu2A', lat: 23.0268433, lon: 72.6391033 },
    { id: 'AMCR0003', name: 'Chakudiya', gmap_location_key: '8zycv3hDpVaj1zxT9', lat: 23.01755, lon: 72.6236317 },
    { id: 'AMCR0007', name: 'Naroda', gmap_location_key: 'xwpp2tZaHrpKuSbc6', lat: 23.0784562, lon: 72.6577954 },
    { id: 'AMCR0024', name: 'Maktampura', gmap_location_key: 'dUDycvRdmYsbzhso9', lat: 22.996347, lon: 72.5347252 },
    { id: 'AMCR0015', name: 'Ranip', gmap_location_key: '7PZ1vzxradMPCacw5', lat: 23.0799652, lon: 72.5706183 },
    { id: 'AMCR0019', name: 'Ramol', gmap_location_key: 'v1RdHbsZS7Ew3f7D9', lat: 22.9565045, lon: 72.654577 },
    { id: 'AMCR0018', name: 'Kathawada', gmap_location_key: '5qhr6fE6eHEptUe36', lat: 23.0579319, lon: 72.7082877 },
    { id: 'AMCR0020', name: 'Nikol', gmap_location_key: 'T6WjHv3J35ShtWWt8', lat: 23.0533459, lon: 72.6696146 },
    { id: 'AMCR0002', name: 'Odhav', gmap_location_key: 'cSuQCjRXBPhqp5P38', lat: 23.0231067, lon: 72.649775 },
    { id: 'AMCW0002', name: 'Main Control', gmap_location_key: 'PgEX2xA7R8biMxUG9', lat: 23.012967, lon: 72.5683644 },
    { id: 'AMCR0028', name: 'Vastral', gmap_location_key: 'uiPDKieNbYhpt1Ry7', lat: 23.0038869, lon: 72.6676491 },
    { id: 'AMCR0029', name: 'Odhav Drange', gmap_location_key: 'VKCixpaVABrHXCq6A', lat: 23.0257947, lon: 72.6727937 },
    { id: 'AMCR0030', name: 'Indrapuri', gmap_location_key: 't3XX2PFZDuqhNBca6', lat: 22.9891417, lon: 72.6307683 },
    { id: 'AMCR0031', name: 'Asarwa', gmap_location_key: 'FKkS26F7WQVLUYwGA', lat: 23.0452437, lon: 72.603304 },
    { id: 'AMCR0032', name: 'Kalupur', gmap_location_key: 'UpAF7xpAXftydnHc7', lat: 23.0364401, lon: 72.5910087 },
    { id: 'AMCR0033', name: 'Motera', gmap_location_key: 'KyUUyLpFe5dddhA48', lat: 23.0747574, lon: 72.5924302 },
    { id: 'AMCR0034', name: 'Memnagar', gmap_location_key: 'Qov3LyZ6WXmmnUTW7', lat: 23.0484047, lon: 72.5388838 },
    { id: 'AMCR0035', name: 'Thaltej', gmap_location_key: 'TsXGbdDZgsE6C9Z78', lat: 23.0572848, lon: 72.5110226 },
    { id: 'AMCR0036', name: 'Bakrol', gmap_location_key: 'YnpotfkkRiwuRwJA7', lat: 22.924727, lon: 72.5095334 },
    { id: 'AMCR0037', name: 'Sarkhej-PAK', gmap_location_key: 'XCav8akxirnr3h3A7', lat: 22.978366, lon: 72.50008 },
    { id: 'AMCR0038', name: 'Sardarnagar', gmap_location_key: 'VqJ5kExz8FowSCMi7', lat: 23.0815317, lon: 72.6320983 },
    { id: 'AMCR0039', name: 'Hanspura', gmap_location_key: 'oWA6QBjAzsixhvC59', lat: 23.0775148, lon: 72.6736548 },
    { id: 'AMCR0040', name: 'Lambha', gmap_location_key: 'X5sNSjhPLmYGbGwT9', lat: 22.9631753, lon: 72.5915083 },
    { id: 'AMCR0041', name: 'Navrangpura', gmap_location_key: 'o2PdzNZGKqbfCSUi7', lat: 23.0358642, lon: 72.5631594 },
    { id: 'AMCR0042', name: 'Ognaj', gmap_location_key: 'YaT6Xa7jF8CsRFNC9', lat: 23.1124401, lon: 72.5156178 },
  ],
  analysis_layers: [
    {
      id: 1,
      file: 'AMC_Zones',
      label: 'AMC Zones',
      visible: false,
      type: 'rectangle',
      color: '#ffff00',
      fillColor: '#efefef',
      weight: 2,
      fillOpacity: 0.6,
    },
    {
      id: 2,
      file: 'Water_Logging_Spots',
      label: 'Water Logging Spots',
      visible: false,
      type: 'image',
      url: 'https://maps.google.com/mapfiles/kml/shapes/water.png',
    },
    {
      id: 3,
      file: 'Kharicut_Canal',
      label: 'Kharicut Canal',
      type: 'polyline',
      fillColor: '#ff0000',
      color: '#55aaff',
      weight: 3,
      visible: false,
    },
    {
      id: 4,
      file: 'Sewage_Manholes',
      label: 'Sewage Manholes',
      visible: false,
      type: 'image',
      url: 'https://maps.google.com/mapfiles/kml/shapes/target.png',
    },
    {
      id: 5,
      file: 'Sewage_Pumping_Station',
      label: 'Sewage Pumping Station',
      url: 'https://maps.google.com/mapfiles/kml/shapes/square.png',
      type: 'image',
      visible: false,
    },
    {
      id: 6,
      file: 'Sewage_Treatment_Plant',
      label: 'Sewage Treatment Plant',
      type: 'image',
      url: 'https://maps.google.com/mapfiles/kml/shapes/triangle.png',
      visible: false,
    },
    {
      id: 7,
      file: 'Sewer_Network',
      label: 'Sewer Network',
      type: 'polyline',
      color: '#5f0f40',
      weight: 3,
      visible: false,
    },
    {
      id: 8,
      file: 'Stormwater_Network',
      label: 'Stormwater Network',
      type: 'polyline',
      weight: 3,
      color: '#55aaff',
      visible: false,
    },
    {
      id: 9,
      file: 'Stormwater_Pump',
      label: 'Stormwater Pump',
      url: 'https://maps.google.com/mapfiles/kml/shapes/open-diamond.png',
      type: 'image',
      visible: false,
    },
    {
      id: 10,
      file: 'Stormwater_Pumping_Station',
      label: 'Stormwater Pumping Station',
      url: 'https://maps.google.com/mapfiles/kml/shapes/donut.png',
      type: 'image',
      visible: false,
    },
    {
      id: 11,
      file: 'Water_Bodies',
      label: 'Water Bodies',
      type: 'rectangle',
      color: '#0055ff',
      weight: 2,
      fillColor: '#0055ff',
      fillOpacity: 0.4,
      visible: false,
    },
  ],
}

const getters = {
  wards: (state) => state.wards,
  averageRainfall: (state) => meanBy(state.wards, (ward) => ward.rainfall),
  r_x00: (state) => (Math.ceil(state.rainfall) > 5 ? 10 : Math.ceil(state.rainfall > 2) ? 5 : 2),
  analysis_layers: (state) => filter(state.analysis_layers, { visible: true }),
  weather_stations: async (state) => {
    const urls = state.weather_stations.map((station) => {
      return `https://cloudflare-cors-anywhere.merasite.workers.dev?https://argamc.komoline.com/Api/GetRainData?stationId=${station.id}&token=UmFpbkFQSTIwMjZAR2VjdXJlMTIz`
    })

    let res = await Promise.all(urls.map((url) => fetch(url)))
    let data = await Promise.all(res.map((r) => r.json()))

    state.weather_stations.forEach((station, index) => {
      if (isNull(station.lat) || isNull(station.lon)) {
        state.weather_stations.splice(index, 1)
      }
      station.JSON = data[index]
    })

    return state.weather_stations
  },
}

const actions = {
  async fetchWards({ commit, getters }) {
    let cached = localStorage.getItem('fewdss-storage')

    if (cached) {
      state.wards = JSON.parse(cached)
    } else {
      const sheetId = '1UxQI9CnbqRh3P3Ta5PfB9B6R6kjuLxBl6cgi1aGJnPY'
      const service = 'https://opensheet.elk.sh'

      cached = await fetch(`${service}/${sheetId}/Sheet1`).then((r) => r.json())
    }

    cached.forEach((item) => {
      item.id = parseInt(item.id)
      item.lat = parseFloat(item.lat)
      item.lon = parseFloat(item.lon)
      item.area = parseFloat(item.area)
      item.i_100 = parseFloat(item.i_100)
      item.i_200 = parseFloat(item.i_200)
      item.i_300 = parseFloat(item.i_300)
      item.i_400 = parseFloat(item.i_400)
      item.rainfall = parseFloat(item.rainfall)
    })

    commit('saveWards', cached)
    commit('saveRainfall', getters.averageRainfall * 0.0394)

    return new Promise((callback) => {
      callback()
    })
  },
  setRainfall: ({ commit }, rainfall) => {
    commit('saveRainfall', Math.ceil(rainfall * 0.0394))
  },
}

const mutations = {
  saveWards: (state, wards) => (state.wards = wards),
  saveRainfall: (state, rainfall) => {
    if (rainfall < 0.01) rainfall = 0
    state.rainfall = rainfall
  },
  saveAnalysisLayers: (state, layers) => {
    state.analysis_layers.forEach((layer, index) => {
      state.analysis_layers[index].visible = indexOf(layers, layer.id) !== -1 ? true : false
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
